<template>
    <div class="m-addTheoryGraphic">
        <div v-if="!paperData.length" class="manual-no-topic">
            <p>{{ $t('paper.clickBtnAddTopic') }}</p>
            <div class="btn-group">
                <el-button type="primary" @click="openSelector">{{ $t('paper.addTopic') }}</el-button>
            </div>
        </div>

        <div v-if="paperData.length" class="paper-container">
            <aside class="paper-aside">
                <sticky :stickyTop="130" scroller=".sub-page .el-main">
                    <div class="paper-aside-wrap">
                        <div class="paper-aside-box category">
                            <p>图片题：{{ count.num }} {{ $t('paper.dao') }}</p>
                            <p>{{ $t('paper.eachTopic') }}：
                                <el-input-number
                                    v-model="score" size="mini" :min="1" :max="50"></el-input-number>
                                {{ $t('paper.points') }}
                            </p>
                            <p>{{ $t('paper.totalScores') }}：{{ count.total }} {{ $t('paper.points') }}</p>
                            <p>{{ $t('paper.passScore') }}：{{ count.pass }} {{ $t('paper.points') }}</p>
                        </div>

                        <div class="btn-group btn-aside">
                            <el-button class="btn-other" @click="openSelector"><i
                                class="nucfont inuc-add-circle"></i>
                                {{ $t('paper.addTopic') }}
                            </el-button>

                            <el-button class="btn-other" @click="previewPaper"><i class="nucfont inuc-preview"></i>
                                {{ $t('paper.previewPaper') }}
                            </el-button>

                            <el-button type="primary"
                                       class="btn-submit"
                                       @click="submitPaper"
                                       :loading="submitLoading"
                                       :disabled="!paperData.length"><i class="nucfont inuc-step-right"></i>
                                {{ $t('paper.savePaper') }}
                            </el-button>
                        </div>
                    </div>
                </sticky>
            </aside>

            <ul class="paper-list" v-viewer>
                <li v-for="(item, index) in paperData" :key="index">
                    <!-- 题干 -->
                    <div class="topic-title">
                        <p class="type">【{{item.number}}，图片题，{{['', '快速判断', '位置标记', '位置标记及类型选择'][item.pattern]}}】</p>
                        <p class="titleRT" v-html="item.titleRT"></p>
                    </div>
                    <div class="topic-main">
                        <div class="img-wrap">
                            <img class="img-question" :src="item.picSrcUrl" alt="考试图">
                            <el-tag size="mini">考试图片</el-tag>
                        </div>
                        <div class="img-wrap">
                            <img class="img-answer" :src="item.picViewUrl" alt="答案图">
                            <el-tag v-if="item.isSafe" type="success" size="mini" dark>答案图（安全）</el-tag>
                            <el-tag v-else type="danger" size="mini">答案图（嫌疑）</el-tag>
                        </div>
                    </div>
                    <div class="others" v-if="item.analysisRT">
                        <p class="analysis" v-html="
                            `<span class=tag>${$t('paper.analysis')}：</span>` + (item.analysisRT||$t('c.none')) "
                        ></p>
                    </div>
                    <div class="btn-operate">
                        <a class="btn-edit" @click="keyTopic(index)" :title="$t('paper.keyQuestion')">
                            <i class="nucfont inuc-favor" :class="{'inuc-favor-fill': item.isKey}"></i></a>
                        <a class="btn-edit"
                           v-if="trainerID === item.creatorID"
                           @click="editTopic(item, index)" :title="$t('paper.editPaper')">
                            <i class="nucfont inuc-edit"></i></a>
                        <a class="btn-delete" @click="deleteTopic(index)" :title="$t('c.delete')">
                            <i class="nucfont inuc-delete"></i></a>
                    </div>
                </li>
            </ul>
        </div>

        <theory-graphic-selector
            :selectorDialog.sync="selectorDialog"
            @selector-save="onSelectorSave"
        ></theory-graphic-selector>

        <el-backtop target=".sub-page .el-main"></el-backtop>

        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view @onSave="editTopicSuccess"></router-view>
        </transition>
    </div>
</template>

<script>
import api from '@/api'
import {mapGetters} from 'vuex'
import {screenfull, Ticket} from '@/utils'
import sticky from '@/components/Sticky'
import TheoryGraphicSelector from "../Components/TheoryGraphicSelector";

export default {
    props: {
        passLine: {},
        paperName: {},
        knowledgeName: {},
        forLevel: {},
        difficulty: {},
        editData: {},
    },
    components: {
        sticky,
        TheoryGraphicSelector
    },
    data() {
        return {
            score: 0,
            paperData: [],
            submitLoading: false,
            trainerID: Ticket.get().userID,

            selectorDialog: false,
        }
    },
    mounted() {
        if (this.editData) {
            let data = [...this.editData.relationship]

            data.forEach((val, index) => {
                this.paperData.push(val.topic)
                this.$set(this.paperData[index], 'isKey', val.key)

                // 加载分数
                this.score = val.score
            })

            console.log(this.paperData)
        }
    },
    computed: {
        count() {
            let obj = {
                num: this.paperData.length,
                total: 0,
                pass: 0
            }

            obj.total = (this.score * obj.num).toFixed(2)
            obj.pass = (obj.total * this.passLine).toFixed(2)

            return obj
        },
        ...mapGetters([]),
    },

    methods: {
        keyTopic(index) {
            this.$set(this.paperData[index], 'isKey', !this.paperData[index].isKey)
        },

        editTopic(item, index) {
            let name = this.editData ? 'editPaperTheoryGraphic' : 'addPaperTheoryGraphic'
            //this.$router.push({name, params: {topic: item, topicIndex: index}})
            this.$router.push({name, query: {id: item.id, idx: index}})
        },
        editTopicSuccess(data, index) {
            Object.assign(this.paperData[index], data)
        },
        deleteTopic(index) {
            this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                type: 'warning'
            }).then(() => {
                this.paperData.splice(index, 1)
            }).catch(() => {})
        },

        // 图像选择器
        openSelector() {
            this.selectorDialog = true
        },
        onSelectorSave(data) {
            this.paperData = this.paperData.concat(data)
        },

        formatPaper() {
            let submitData = {
                passLine: this.passLine,
                title: this.paperName,
                knowledge: this.knowledgeName[this.knowledgeName.length - 1],
                forLevel: this.forLevel,
                difficulty: this.difficulty,
                relationship: []
            }

            this.paperData.forEach(val => {
                let info = {}
                info.topicID = val.id
                info.score = this.score
                info.key = val.isKey
                submitData.relationship.push(info)
            })

            return submitData
        },

        previewPaper() {
            let previewData

            previewData = this.formatPaper()

            Object.assign(previewData, {
                totalScore: this.count.total,
                passScore: this.count.pass,
                graphicScore: this.score,
                method: 5
            })

            previewData.relationship.forEach(item => {
                item.topic = this.paperData.find(v => v.id == item.topicID)
            })

            let name = this.editData ? 'editTheoryPaperPreview' : 'addTheoryPaperPreview'
            this.$router.push({name, params: {data: previewData}})
            screenfull.request()
        },

        submitPaper() {
            let submitData = this.formatPaper()
            //删除这个多余参数
            submitData.relationship.forEach(v => delete v.isKey)
            this.submitLoading = true

            if (this.editData) {
                api.putPaper(this.editData.id, submitData).then(res => {
                    this.submitSuccess(this.$t('paper.editPaperSuccess') + '！')
                }).catch(error => this.submitLoading = false)
            } else {
                submitData.type = 1
                api.postPaper(submitData).then(res => {
                    this.submitSuccess()
                }).catch(error => this.submitLoading = false)
            }
        },
        submitSuccess(msg = this.$t('paper.theoryPaperMakeSuccess') + '！') {
            this.submitLoading = false
            this.$notify.success({
                title: this.$t('c.success'),
                message: msg,
                type: 'success',
                duration: 2000
            })
            this.$emit('needUpdate')
            this.$router.replace({name: 'myPaper'})
        },

    },
}
</script>

<style lang="scss">
@import '~@/style/const';

.m-addTheoryGraphic {

    .paper-list {
        > li {
            position: relative;
            margin-bottom: 14px;
            padding: 15px 20px 10px 20px;
            font-size: 13px;
            color: #333;
            background-color: #f5f7fa;
            border-radius: 4px;
        }

        .topic-title {
            margin-bottom: 14px;

            .type {
                margin-bottom: 10px;
                margin-left: -5px;
                color: #f4516c;
            }
            .titleRT {
                font-size: 14px;
                line-height: 1.5;
            }
        }

        .topic-main {
            display: flex;
            margin-bottom: 10px;
            .img-wrap {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 320px;
                height: 240px;
                margin-right: 10px;
                background-color: #fff;

                > img {
                    max-width: 100%;
                    max-height: 100%;
                    cursor: pointer;
                }
                .el-tag {
                    position: absolute;
                    right: 0;
                    top: 0;
                }
            }
        }

        .others {
            border-top: dashed 1px #d8d8d8;
            .analysis {
                margin-top: 8px;
            }
            .tag {
                color: #2e7faa;
            }
        }

        .btn-operate {
            position: absolute;
            right: 12px;
            top: 18px;

            > a {
                display: inline-block;
                margin-right: 9px;
                cursor: pointer;
                color: #999;

                .nucfont {
                    font-size: 18px;
                }

                &.btn-edit:hover,
                .inuc-favor-fill {
                    color: $color-theme;
                }

                &.btn-delete:hover {
                    color: $c-danger;
                }
            }
        }

    }
}

</style>
